<template>
  <account-component 
    @submitEditUser="handleSubmitEditUser"
    @submitEditPassword="handleSubmitEditPassword" >
  </account-component>
</template>

<script>
import AccountComponent from '@/components/user/AccountComponent'
import { mapGetters, mapMutations } from 'vuex'
import axios from "axios";

export default {
    components: {AccountComponent},
    name:"Landing",
    computed: {
        ...mapGetters ([
            'base_url', 'currentMethodID', 'auth_header'
        ])
    },
    methods: {        
      ...mapMutations([
          'SET_BREADCRUMB'
      ]),
      setBreadcrumb: function(){
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
      },
      handleSubmitEditUser: function(user) {
        axios
          .patch(`${this.base_url}accounts/user/`, user,
            { 
              headers: this.auth_header
            }
          )
          .then(response => {
            console.log("User info Successfully Updated:", user);
            this.$toast.open({
                duration: 5000,
                message: `Information Successfully Updated`,
                position: 'is-top',
                type: 'is-primary'
            })
            this.$store.dispatch('update_user', user);
            this.$router.push({ name: "Account", params: {  } });
          })
          .catch(error => {
            this.$toast.open({
                duration: 5000,
                message: error.response.data,
                position: 'is-top',
                type: 'is-danger'
            })
            console.log("Information was not successfully updated: ", error.response.data);
          });
      },
      handleSubmitEditPassword: function(user) {
        axios
          .post(`${this.base_url}accounts/password/change/`, user,
            { 
              headers: this.auth_header
            }
          )
          .then(response => {
            console.log("Password Successfully Changed:", user);
            this.$toast.open({
                duration: 5000,
                message: `Password Successfully Changed`,
                position: 'is-top',
                type: 'is-primary'
            })
            // maybe here
            this.$router.push({ name: "Account", params: {  } });
          })
          .catch(error => {
            this.$toast.open({
                duration: 5000,
                message: error.response.data,
                position: 'is-top',
                type: 'is-danger'
            })
            console.log("Password was not successfully updated: ", error.response.data);
          });
      }
    },
    mounted: function(){
        this.setBreadcrumb()
    }
  }
</script>